<footer *transloco="let t" class="footer">
    <div class="city-background"></div>
    <div class="boy-background"></div>
    <div class="rotated-background"></div>
    <div class="footer-links">
        <a [href]="appConfig.termsUrl" rel="external" target="_blank">{{ t('GENERAL_TERMS_AND_CONDITIONS') }}</a>
        <a [href]="appConfig.privacyUrl" rel="external" target="_blank">{{ t('PRIVACY_STATEMENT') }}</a>
    </div>
</footer>
